import React, { useEffect } from "react";
import styles from "./Register.module.css";
import { useState } from "react";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Navigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { Password } from "primereact/password";
import { uiActions } from "../../../store/ui-slice";
import { userActions } from "../../../store/auth-store/auth-slice";
import { RegisterUser } from "../../../store/auth-store/auth-actions";
import { GetCharges } from "../../../store/charge-store/charge-actions";
import { GetDepartments } from "../../../store/department-store/department-actions";
import { countriesArray } from "../../../components/List";
import { GetCompanies } from "../../../store/company-store/company-actions";
import { InputMask } from "primereact/inputmask";
import Loading from "../../../components/loading/Loading";

const Register = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    ""
  );
  const [selectedCharge, setSelectedCharge] = useState({ code: 0, name: "" });
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState({
    code: 0,
    name: "",
  });
  const [countries, setCountries] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [charges, setCharges] = useState([]);
  const [departments, setDepartments] = useState([]);

  const company = useSelector((state) => state.company);
  const charge = useSelector((state) => state.charge);
  const department = useSelector((state) => state.department);
  const country = countriesArray;
  const user = useSelector((state) => state.auth.auth);

  const [invalidField, setInvalidField] = useState("");

  const dispatch = useDispatch();
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (userInfo !== undefined && userInfo !== null && userInfo.UserId !== null && userInfo.UserId !== undefined) {
      window.location.href = "/";
    }
  });

  useEffect(() => {
    if (company.companies === undefined || company.companies.length === 0) {
      dispatch(GetCompanies("capacitaciones@aba.org.do"));
    }
  });

  useEffect(() => {
    if (charge.charges === undefined || charge.charges.length === 0) {
      dispatch(GetCharges("capacitaciones@aba.org.do", true));
    }
  });

  useEffect(() => {
    if (
      department.departments === undefined ||
      department.departments.length === 0
    ) {
      dispatch(GetDepartments("capacitaciones@aba.org.do", true));
    }
  }, [department.departments, dispatch]);

  useEffect(() => {
    if (charge.charges !== undefined && charge.charges.length > 0) {
      const listCharges = charge.charges.map((charge) => {
        return {
          code: charge.id,
          name: charge.name,
        };
      });
      setCharges(listCharges);
    }
  }, [charge.charges]);

  useEffect(() => {
    if (company.companies !== undefined && company.companies.length > 0) {
      const listCompanies = company.companies.map((company) => {
        return {
          code: company.id,
          name: company.name,
          rnc: company.rnc,
        };
      });
      setCompanies(listCompanies);
    }
  }, [company.companies]);

  useEffect(() => {
    if (country !== undefined && country.length > 0) {
      var id = 0;
      const listCountries = country.map((country) => {
        id++;
        return {
          code: country.name,
          name: country.name,
          flag: country.abreviatura,
        };
      });
      setCountries(listCountries);
    }
  }, [country]);

  useEffect(() => {
    if (
      department.departments !== undefined &&
      department.departments.length > 0
    ) {
      const listDepartments = department.departments.map((department) => {
        return {
          code: department.id,
          name: department.name,
        };
      });
      setDepartments(listDepartments);
    }
  }, [department.departments]);

  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="flex align-items-center">
          <img
            alt={option.name}
            src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
            style={{ width: "18px" }}
          />
          <div style={{ marginLeft: "5%" }}>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const onChangeCountriesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCountry({
      code: value.code,
      name: value.name,
      flag: value.flag,
    });
  };

  const onChangeCompaniesHandler = (id, value) => {
    if (value.name !== undefined && value.name !== "" && value.name !== null) {
      dispatch(
        userActions.modifyPropertyValue({
          id,
          value: {
            id: value.code,
            name: value.name,
          },
        })
      );
      setSelectedCompany(value.name);
    } else {
      dispatch(
        userActions.modifyPropertyValue({
          id,
          value: {
            id: 0,
            name: value,
          },
        })
      );
      setSelectedCompany(value);
    }
  };

  const countryOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center" style={{ width: "100px" }}>
        <img
          alt={option.name}
          src={`https://flagcdn.com/48x36/${option.flag.toLowerCase()}.png`}
          style={{ width: "18px" }}
        />
        <div style={{ marginLeft: "5%" }}>{option.name}</div>
      </div>
    );
  };

  const onChangeChargesHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedCharge({
      code: value.code,
      name: value.name,
    });
  };

  const onChangeDepartmentHandler = (id, value) => {
    dispatch(userActions.modifyPropertyValue({ id, value: value.code }));
    setSelectedDepartment({
      code: value.code,
      name: value.name,
    });
  };

  const onChangeHandler = (id, value) => {
    if (id !== "charge" && id !== "department") {
      dispatch(userActions.modifyPropertyValue({ id, value }));
      if (value !== "") {
        dispatch(userActions.setFieldValid({ id, value: true }));
      } else {
        dispatch(userActions.setFieldValid({ id, value: false }));
      }
    } else {
      dispatch(userActions.modifyPropertyValue({ id, value: { id: value } }));
    }
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    setInvalidField("");

    if (user.name === "") {
      dispatch(
        uiActions.showNotification({
          message: "El nombre es requerido",
          status: "warning",
        })
      );
      setInvalidField("name");
      return;
    } else if (user.email === "") {
      dispatch(
        uiActions.showNotification({
          message: "El email es requerido",
          status: "warning",
        })
      );
      setInvalidField("email");
      return;
    } else if (user.password === "") {
      dispatch(
        uiActions.showNotification({
          message: "La contraseña es requerida",
          status: "warning",
        })
      );
      setInvalidField("password");
      return;
    } else if (user.repassword === "") {
      dispatch(
        uiActions.showNotification({
          message: "La confirmación de la contraseña es requerida",
          status: "warning",
        })
      );
      setInvalidField("repassword");
      return;
    } else if (user.lastName === "") {
      dispatch(
        uiActions.showNotification({
          message: "El apellido es requerido",
          status: "warning",
        })
      );
      setInvalidField("lastName");
      return;
    }
    else if (user.cellPhone === "") {
      dispatch(
        uiActions.showNotification({
          message: "El teléfono es requerido",
          status: "warning",
        })
      );
      setInvalidField("cellPhone");
      return;
    }
    else if (user.city === "") {
      dispatch(
        uiActions.showNotification({
          message: "La ciudad es requerida",
          status: "warning",
        })
      );
      setInvalidField("city");
      return;
    }
    else if (user.address === "") {
      dispatch(
        uiActions.showNotification({
          message: "La dirección es requerida",
          status: "warning",
        })
      );
      setInvalidField("address");
      return;
    }
    else if (!selectedCountry) {
      dispatch(
        uiActions.showNotification({
          message: "El país es requerido",
          status: "warning",
        })
      );
      setInvalidField("country");
      return;
    }
    else if (!selectedCompany) {
      dispatch(
        uiActions.showNotification({
          message: "La empresa es requerida",
          status: "warning",
        })
      );
      setInvalidField("company");
      return;
    }
    else if (!selectedDepartment.code) {
      dispatch(
        uiActions.showNotification({
          message: "El departamento es requerido",
          status: "warning",
        })
      );
      setInvalidField("department");
      return;
    }
    else if (!selectedCharge.code) {
      dispatch(
        uiActions.showNotification({
          message: "El cargo es requerido",
          status: "warning",
        })
      );
      setInvalidField("charge");
      return;
    }
    

    if (user.password === user.repassword) {
      const newUser = {
        ...user,
        charge: {
          id: selectedCharge.code,
          name: selectedCharge.name,
        },
        department: {
          id: selectedDepartment.code,
          name: selectedDepartment.name,
        },
        country: selectedCountry.name,
        company: {
          id: user.company.id,
          name: user.company.name,
        },
      };

     await dispatch(RegisterUser(newUser));

     setTimeout(() => {
     window.location.href = "/";
      }, 2000);
    } else {
      dispatch(
        uiActions.showNotification({
          message: "Las contraseñas no coinciden",
          status: "error",
        })
      );
    }
  };
  return (
    <>
      {countries.length <= 0 && companies.length <= 0 && charges.length <= 0 && (<Loading />)}
      {countries.length > 0 && companies.length > 0 && charges.length > 0 && (
        <div className={styles.profile}>
          <div className={styles.header}>
            <div className={styles.profileInfo}>
              <Button
                className={styles.profileIcon}
                icon="pi pi-user-plus"
                rounded
                outlined
                severity="info"
                aria-label="User"
              />
              <div className={styles.infoContainer}>
                <h1 className={styles.profileName}>Registrarse</h1>
              </div>
            </div>
          </div>
          <div className={styles.profileForm}>
            <form className={styles.forms}>
              <div className={styles.column}>
                <label htmlFor="nombre">Nombre</label>
                <InputText
                  onChange={(e) => onChangeHandler("name", e.target.value)}
                  value={user.Name}
                  type="text"
                  id="name"
                  invalid={invalidField === "name"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="apellido">Apellido</label>
                <InputText
                  onChange={(e) => onChangeHandler("lastName", e.target.value)}
                  value={user.Lastname}
                  type="text"
                  id="lastName"
                  invalid={invalidField === "lastName"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="email">Email</label>
                <InputText
                  onChange={(e) => onChangeHandler("email", e.target.value)}
                  value={user.Email}
                  type="text"
                  id="email"
                  invalid={invalidField === "email"}
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="cargo">Contraseña</label>
                <Password
                  onChange={(e) => onChangeHandler("password", e.target.value)}
                  className={styles.passwordInput}
                  value={user.Password}
                  type="text"
                  id="password"
                  feedback={false}
                  invalid={invalidField === "password"}
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="confirmar contraseña">
                  Confirmar contraseña
                </label>
                <Password
                  onChange={(e) =>
                    onChangeHandler("repassword", e.target.value)
                  }
                  className={styles.passwordInput}
                  value={user.Repassword}
                  type="text"
                  id="repassword"
                  feedback={false}
                  invalid={invalidField === "repassword"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="telefono">Teléfono</label>
                <InputMask
                  id="cellPhone"
                  value={user.cellPhone}
                  onChange={(e) => onChangeHandler("cellPhone", e.target.value)}
                  mask="+1999-999-9999"
                  placeholder="+1999-999-9999"
                  style={{
                    width: !isMobile ? "100%" : "70%",
                    marginRight: "3%",
                  }}
                  invalid={invalidField === "cellPhone"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="pais">País</label>
                <Dropdown
                  value={selectedCountry}
                  onChange={(e) => {
                    onChangeCountriesHandler("countryid", e.value);
                  }}
                  options={countries}
                  optionLabel="name"
                  placeholder="Seleccionar pais"
                  valueTemplate={selectedCountryTemplate}
                  filter
                  itemTemplate={countryOptionTemplate}
                  className={styles.profileDropdown}
                  invalid={invalidField === "country"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="ciudad">Ciudad</label>
                <InputText
                  onChange={(e) => onChangeHandler("city", e.target.value)}
                  value={user.City}
                  type="text"
                  id="city"
                  invalid={invalidField === "city"}
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="direccion">Dirección</label>
                <InputText
                  onChange={(e) => onChangeHandler("address", e.target.value)}
                  value={user.Address}
                  type="text"
                  id="address"
                  invalid={invalidField === "address"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="empresa">Empresa</label>
                <Dropdown
                  className={styles.companyDropdown}
                  onChange={(e) => onChangeCompaniesHandler("company", e.value)}
                  options={companies}
                  optionLabel="name"
                  editable
                  placeholder="Seleccionar empresa"
                  value={selectedCompany}
                  // type="text"
                  id="company"
                  invalid={invalidField === "company"}
                />
              </div>

              <div className={styles.column}>
                <label htmlFor="departamento">Departamento</label>
                <Dropdown
                  onChange={(e) =>
                    onChangeDepartmentHandler("department", e.value)
                  }
                  optionLabel="name"
                  value={selectedDepartment}
                  options={departments}
                  className={styles.profileDropdown}
                  placeholder="Seleccionar departamento"
                  defaultValue={""}
                  filter
                  id="department"
                  invalid={invalidField === "department"}
                />
              </div>
              <div className={styles.column}>
                <label htmlFor="cargo">Cargo</label>
                <Dropdown
                  onChange={(e) => onChangeChargesHandler("charge", e.value)}
                  value={selectedCharge}
                  options={charges}
                  optionLabel="name"
                  className={styles.profileDropdown}
                  placeholder="Seleccionar cargo"
                  defaultValue={""}
                  filter
                  // type="text"
                  id="charge"
                  invalid={invalidField === "charge"}
                />
              </div>
            </form>
            <Button
              onClick={onSubmitHandler}
              className={styles.saveButton}
              label="Guardar"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Register;
